"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentApi = exports.FreeFieldCode = exports.ThematicCode = exports.InterestCode = exports.ActivityCode = exports.ContentType = exports.ProjectCode = void 0;
const globalImportUrl = require("url");
const base_1 = require("../base");
const axios_1 = require("axios");
var ProjectCode;
(function (ProjectCode) {
    ProjectCode["Supply"] = "supply";
    ProjectCode["Commercialization"] = "commercialization";
    ProjectCode["Funding"] = "funding";
    ProjectCode["Courses"] = "courses";
    ProjectCode["Management"] = "management";
    ProjectCode["Hardware"] = "hardware";
    ProjectCode["Transition"] = "transition";
    ProjectCode["Diversification"] = "diversification";
    ProjectCode["FarmingLife"] = "farmingLife";
    ProjectCode["Health"] = "health";
    ProjectCode["Replacement"] = "replacement";
})(ProjectCode = exports.ProjectCode || (exports.ProjectCode = {}));
var ContentType;
(function (ContentType) {
    ContentType["Article"] = "article";
    ContentType["Event"] = "event";
    ContentType["PlcService"] = "plcService";
    ContentType["AffiliateService"] = "affiliateService";
    ContentType["Guide"] = "guide";
    ContentType["Startup"] = "startup";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var ActivityCode;
(function (ActivityCode) {
    ActivityCode["BigCrops"] = "bigCrops";
    ActivityCode["Breeding"] = "breeding";
    ActivityCode["FruitsVegetables"] = "fruitsVegetables";
    ActivityCode["Wine"] = "wine";
})(ActivityCode = exports.ActivityCode || (exports.ActivityCode = {}));
var InterestCode;
(function (InterestCode) {
    InterestCode["AgriculturalSituation"] = "agriculturalSituation";
    InterestCode["Agroecology"] = "agroecology";
    InterestCode["AidAndIncome"] = "aidAndIncome";
    InterestCode["Climate"] = "climate";
    InterestCode["CoursesMarket"] = "coursesMarket";
    InterestCode["FarmIncome"] = "farmIncome";
    InterestCode["Innovation"] = "innovation";
    InterestCode["InstallationAndTransmission"] = "installationAndTransmission";
    InterestCode["Machinery"] = "machinery";
    InterestCode["MarketingOutlets"] = "marketingOutlets";
    InterestCode["Politics"] = "politics";
    InterestCode["ProductionTechniques"] = "productionTechniques";
    InterestCode["Regulatory"] = "regulatory";
    InterestCode["Sanitary"] = "sanitary";
})(InterestCode = exports.InterestCode || (exports.InterestCode = {}));
var ThematicCode;
(function (ThematicCode) {
    ThematicCode["Transitions"] = "transitions";
    ThematicCode["FarmManagement"] = "farmManagementThematic";
    ThematicCode["InstallationTransmission"] = "installationTransmission";
    ThematicCode["Innovation"] = "innovationThematic";
})(ThematicCode = exports.ThematicCode || (exports.ThematicCode = {}));
var FreeFieldCode;
(function (FreeFieldCode) {
    FreeFieldCode["Home"] = "home";
    FreeFieldCode["Meteo"] = "meteo";
})(FreeFieldCode = exports.FreeFieldCode || (exports.FreeFieldCode = {}));
function ContentApiAxiosParamCreator(configuration) {
    return {
        getArticle(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling getArticle.");
            }
            const localVarPath = `/articles/{slug}`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getComments(articleId, offset, limit, options = {}) {
            if (articleId === null || articleId === undefined) {
                throw new base_1.RequiredError("articleId", "Required parameter articleId was null or undefined when calling getComments.");
            }
            const localVarPath = `/articles/{articleId}/comments`.replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (offset !== undefined) {
                localVarQueryParameter["offset"] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter["limit"] = limit;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getEvent(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling getEvent.");
            }
            const localVarPath = `/events/{slug}`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFreeField(freeFieldCode, options = {}) {
            if (freeFieldCode === null || freeFieldCode === undefined) {
                throw new base_1.RequiredError("freeFieldCode", "Required parameter freeFieldCode was null or undefined when calling getFreeField.");
            }
            const localVarPath = `/free-fields/{freeFieldCode}`.replace(`{${"freeFieldCode"}}`, encodeURIComponent(String(freeFieldCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMostViewArticles(limit, options = {}) {
            const localVarPath = `/articles/most-viewed`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter["limit"] = limit;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRelatedArticles(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling getRelatedArticles.");
            }
            const localVarPath = `/articles/{slug}/related`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRelatedEvents(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling getRelatedEvents.");
            }
            const localVarPath = `/events/{slug}/related`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getViewCount(articleId, options = {}) {
            if (articleId === null || articleId === undefined) {
                throw new base_1.RequiredError("articleId", "Required parameter articleId was null or undefined when calling getViewCount.");
            }
            const localVarPath = `/articles/{articleId}/view-count`.replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PATCH" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        insertComment(articleId, lightComment, options = {}) {
            if (articleId === null || articleId === undefined) {
                throw new base_1.RequiredError("articleId", "Required parameter articleId was null or undefined when calling insertComment.");
            }
            if (lightComment === null || lightComment === undefined) {
                throw new base_1.RequiredError("LightComment", "Required parameter LightComment was null or undefined when calling insertComment.");
            }
            const localVarPath = `/articles/{articleId}/comments`.replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof lightComment !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(lightComment !== undefined ? lightComment : {})
                : lightComment || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function ContentApiFp(configuration) {
    return {
        getArticle(slug, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).getArticle(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getComments(articleId, offset, limit, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).getComments(articleId, offset, limit, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getEvent(slug, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).getEvent(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getFreeField(freeFieldCode, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).getFreeField(freeFieldCode, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getMostViewArticles(limit, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).getMostViewArticles(limit, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getRelatedArticles(slug, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).getRelatedArticles(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getRelatedEvents(slug, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).getRelatedEvents(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getViewCount(articleId, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).getViewCount(articleId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        insertComment(articleId, LightComment, options) {
            const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).insertComment(articleId, LightComment, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class ContentApi extends base_1.BaseAPI {
    getArticle(slug, options) {
        return ContentApiFp(this.configuration).getArticle(slug, options)(this.axios, this.basePath);
    }
    getComments(articleId, offset, limit, options) {
        return ContentApiFp(this.configuration).getComments(articleId, offset, limit, options)(this.axios, this.basePath);
    }
    getEvent(slug, options) {
        return ContentApiFp(this.configuration).getEvent(slug, options)(this.axios, this.basePath);
    }
    getFreeField(freeFieldCode, options) {
        return ContentApiFp(this.configuration).getFreeField(freeFieldCode, options)(this.axios, this.basePath);
    }
    getMostViewArticles(limit, options) {
        return ContentApiFp(this.configuration).getMostViewArticles(limit, options)(this.axios, this.basePath);
    }
    getRelatedArticles(slug, options) {
        return ContentApiFp(this.configuration).getRelatedArticles(slug, options)(this.axios, this.basePath);
    }
    getRelatedEvents(slug, options) {
        return ContentApiFp(this.configuration).getRelatedEvents(slug, options)(this.axios, this.basePath);
    }
    getViewCount(articleId, options) {
        return ContentApiFp(this.configuration).getViewCount(articleId, options)(this.axios, this.basePath);
    }
    insertComment(articleId, LightComment, options) {
        return ContentApiFp(this.configuration).insertComment(articleId, LightComment, options)(this.axios, this.basePath);
    }
}
exports.ContentApi = ContentApi;
